import React from 'react'

import { MarkdownDataProvider } from '~contexts/MarkdownDataContext'

import style from './Tabs.module.scss'

import Labels from './Labels'

/**
 * A wrapper around all the tabs. Keeps track of overall
 * state and tracks preference in local storeage
 */
const Tabs = ({ 
  children,
  registerLabel,
  state,
  onSelection
}) => (
  <MarkdownDataProvider data={{ 
    registerLabel,
    state,
    onSelection
  }}>
    <div 
      className={style.tabs} 
      data-js-enabled={state && state.jsEnabled}
    >
      <Labels state={state} onSelection={onSelection} />
      { children }
    </div>
  </MarkdownDataProvider>
)

export default Tabs